import { createSlice } from '@reduxjs/toolkit';

const countSlice = createSlice({
  name: 'count',
  initialState: {
    loading: false,
    success: false,
    failed: false,
    error: null,
    survey_count: 0,
  },
  reducers: {
    fetchCountData(state) {
      state.loading = true;
      state.success = false;
      state.failed = false;
      state.error = null;
    },
    countDataSuccess(state, { payload }) {
      state.loading = false;
      state.failed = false;
      state.success = true;
      state.error = null;
      state.survey_count = payload.survey_count;
    },
    countDataError(state, { payload }) {
      state.loading = false;
      state.failed = true;
      state.error = payload;
    },
  },
});

export const { fetchCountData, countDataSuccess, countDataError } =
  countSlice.actions;

export default countSlice.reducer;
